import { Directive, input } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Directive({
  selector: 'button[lp-button]',
  host: {
    class: 'lp-button',
    '[class]': 'variant()',
    '[attr.outlined]': 'outlined()'
  }
})
export class ButtonDirective {
  public variant = input<'primary' | 'secondary'>('primary');
  public outlined = input(false, { transform: coerceBooleanProperty });
}
